import { MonitorMultipleIcon } from './MonitorMultipleIcon';

/**
 * author: Chris Litherland
 * id 7768BF7B-0A52-4492-88BD-5A482E4D61C3
 * name monitor-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-multiple.svg
 * tags
 * - Device / Tech 
 */
export const MonitorsIcon = MonitorMultipleIcon;
export default MonitorsIcon